import { render, staticRenderFns } from "./PublicityInfo.vue?vue&type=template&id=65fa8a08&scoped=true&"
import script from "./PublicityInfo.vue?vue&type=script&lang=js&"
export * from "./PublicityInfo.vue?vue&type=script&lang=js&"
import style0 from "./PublicityInfo.vue?vue&type=style&index=0&id=65fa8a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa8a08",
  null
  
)

export default component.exports